import { render, staticRenderFns } from "./IssuePhonNewEdit.vue?vue&type=template&id=7299b278&scoped=true&"
import script from "./IssuePhonNewEdit.vue?vue&type=script&lang=js&"
export * from "./IssuePhonNewEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7299b278",
  null
  
)

export default component.exports